import React from 'react';
import { statusListStyle } from './status.styles.css';

type StatusProps = {
    status: React.ReactNode[];
};

export const Status: React.FC<StatusProps> = ({ status }) => {
    return status.length > 0 ? (
        <ul className={statusListStyle}>
            {status.map((badge, index) => (
                <li key={`status-badge-${index}`}>{badge}</li>
            ))}
        </ul>
    ) : null;
};
